/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TeamResource = {
    AccountManager: 'ACCOUNT_MANAGER',
    KeyAccountManager: 'KEY_ACCOUNT_MANAGER',
    KamInterns: 'KAM_INTERNS',
    SalesDevelopmentRepresentativeForSelfService: 'SALES_DEVELOPMENT_REPRESENTATIVE_FOR_SELF_SERVICE',
    SalesDevelopmentRepresentativeForMediumBusinesses: 'SALES_DEVELOPMENT_REPRESENTATIVE_FOR_MEDIUM_BUSINESSES',
    SalesDevelopmentRepresentativeForSmallBusinesses: 'SALES_DEVELOPMENT_REPRESENTATIVE_FOR_SMALL_BUSINESSES',
    SalesDevelopmentRepresentativeOutbound: 'SALES_DEVELOPMENT_REPRESENTATIVE_OUTBOUND',
    Product: 'PRODUCT',
    Tech: 'TECH',
    Marketing: 'MARKETING',
    SourcingManager: 'SOURCING_MANAGER',
    GeneralAdministration: 'GENERAL_ADMINISTRATION',
    FinancialOperations: 'FINANCIAL_OPERATIONS',
    CustomerSuccessManager: 'CUSTOMER_SUCCESS_MANAGER',
    IdpManagedTeam: 'IDP_MANAGED_TEAM'
} as const;
export type TeamResource = typeof TeamResource[keyof typeof TeamResource];


export function instanceOfTeamResource(value: any): boolean {
    for (const key in TeamResource) {
        if (Object.prototype.hasOwnProperty.call(TeamResource, key)) {
            // @ts-ignore
            if (TeamResource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TeamResourceFromJSON(json: any): TeamResource {
    return TeamResourceFromJSONTyped(json, false);
}

export function TeamResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamResource {
    return json as TeamResource;
}

export function TeamResourceToJSON(value?: TeamResource | null): any {
    return value as any;
}

